import { BaseManagerModel } from '../../util/BaseManagerModel';
import { ICategory } from './types';

export class CategoryManager extends BaseManagerModel<ICategory> {
  constructor() {
    super('category');
  }
}

export default new CategoryManager();
